// utils/tabId.js
let tabId = window.name;

if (!tabId) {
    tabId = Date.now().toString();
    window.name = tabId;
}

export default tabId;
